module.exports = __webpack_public_path__ + "img/US - border.74803100.png";